import React, { useState } from "react";

import config from "@app/config";
import { Button } from "@app/scripts/react-general-components/Button";
import { AustraliaSvg } from "@app/scripts/react-geolocation/components/AustraliaSvg";

export type GeolocationProps = {
  detectedCountry?: string;
  shopifyCountry?: string;
  shouldOpenPopup?: boolean;
  btn_text_2_au: string;
  btn_text_2_us: string;
  btn_text_au: string;
  btn_text_us: string;
  sub_title_au: string;
  sub_title_us: string;
  title_au: string;
  title_us: string;
};

export const GeolocationPopup: React.FC<GeolocationProps> = (props) => {
  const { detectedCountry, shopifyCountry, shouldOpenPopup } = props;
  const [isOpen, setIsOpen] = useState(shouldOpenPopup);

  const closePopup = () => {
    setIsOpen(false);
    sessionStorage.setItem("geoPopupClosed", "true");
  };

  const isNorthAmerica = detectedCountry == "US" || detectedCountry == "CA";
  const btnLink = isNorthAmerica ? config.stores["industrie-australia"].url : config.stores["industrie-clothing"].url;

  const content = isNorthAmerica
    ? {
        btn_text: props.btn_text_us,
        btn_text_2: props.btn_text_2_us,
        sub_title: props.sub_title_us,
        title: props.title_us,
      }
    : {
        btn_text_2: props.btn_text_2_au,
        btn_text: props.btn_text_au,
        sub_title: props.sub_title_au,
        title: props.title_au,
      };

  return isOpen ? (
    <div className="geolocation__popup-wrap text-brand-dark-grey">
      <div className="geolocation__popup">
        <div className="geolocation__popup-inner">
          <div className="geolocation__popup-flags">
            {detectedCountry === "US" ? (
              <>
                <ui-icon name="icon-america" width="34" height="22"></ui-icon>
                <ui-icon width="34" height="22" name="icon-canada"></ui-icon>
              </>
            ) : (
              <AustraliaSvg width={33} height={22} />
            )}
          </div>
          <h2 className="h1 bold">{content?.title}</h2>
          <p className="geolocation__popup-text text-lg">{content?.sub_title}</p>
          <Button onClick={closePopup} href={btnLink} label={content?.btn_text} variant="secondary" />
          {shopifyCountry !== "US" && <Button onClick={closePopup} label={content?.btn_text_2} variant="text" />}
        </div>
      </div>
    </div>
  ) : null;
};
